import { Box, Typography, Checkbox, FormControlLabel } from "@mui/material";
import { colorPrimary, colorSubText } from "../../../theme";

interface TipoFilterCardProps {
  values: string[];
  selected: string[];
  onChange: (selected: string[]) => void;
}
export function TipoFilterCard({
  values,
  selected,
  onChange,
}: TipoFilterCardProps) {
  const handleToggle = (value: string) => {
    if (selected.includes(value)) {
      onChange(selected.filter((v) => v !== value));
    } else {
      onChange([...selected, value]);
    }
  };

  return (
    <Box
      sx={{
        bgcolor: "background.paper",
        p: 2,
        borderRadius: 3,
        boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
        border: "1px solid",
        borderColor: "divider",
      }}
    >
      {/* Título */}
      <Box mb={2}>
        <Typography
          fontWeight={700}
          fontSize="0.7rem"
          letterSpacing={1.5}
          textTransform="uppercase"
          color="text.secondary"
        >
          Tipo
        </Typography>

        <Box
          sx={{
            width: 32,
            height: 4,
            bgcolor: colorPrimary,
            mt: 0.5,
            borderRadius: 2,
          }}
        />
      </Box>

      {/* Opções */}
      <Box display="flex" flexDirection="column" gap={2}>
        {values.map((value) => (
          <FormControlLabel
            key={value}
            control={
              <Checkbox
                checked={selected.includes(value)}
                onChange={() => handleToggle(value)}
                color="primary"
              />
            }
            label={
              <Typography
                fontSize="0.85rem"
                fontWeight={600}
                color={colorSubText}
                sx={{
                  transition: "color 0.2s ease",
                  "&:hover": {
                    color: "primary.main",
                  },
                }}
              >
                {value ==="L"? "Leilão": value ==="C"? "Cotação" : value ==='N'? "Compre agora" : "Combo"}
              </Typography>
            }
            sx={{
              ml: 0,
              "&:hover .MuiTypography-root": {
                color: "primary.main",
              },
            }}
          />
        ))}
      </Box>
    </Box>
  );
}
